export const validateScript = (script: string): string[] => {
  const errors: string[] = [];
  if (!/var\s+oneLinkURL\b/.test(script) && !/\boneLinkURL\s*:/.test(script)) {
    errors.push('Missing reference or declaration for "oneLinkURL".');
  }
  if (!/var\s+result\b/.test(script) && !/\bresult\s*=/.test(script)) {
    errors.push('Missing reference or declaration for "result".');
  }
  if (!/window\.AF_SMART_SCRIPT\.generateOneLinkURL\s*\(/.test(script)) {
    errors.push('Missing call to window.AF_SMART_SCRIPT.generateOneLinkURL().');
  }
  return errors;
};
